/**
 * Composite key helpers shared by the stage-categories backend route and
 * the admin Kanban frontend so both sides index mappings the same way.
 *
 * Keep in lock-step with backend/src/lib/stages/normalize.ts.
 */

/** ASCII Unit Separator — used as delimiter in composite Map keys only. */
const COMPOSITE_KEY_SEP = "\x1f";

/**
 * Build a composite Map key from stage + substage for in-memory lookup.
 * Both values should already be trimmed. Case-sensitive.
 */
export function buildStageKey(stage: string, subStage: string): string {
  return `${stage}${COMPOSITE_KEY_SEP}${subStage}`;
}

/**
 * Trim whitespace from a stage/substage value.
 * Returns "" for null/undefined/whitespace-only input.
 */
export function trimStageValue(raw: null | string | undefined): string {
  if (raw == null) return "";
  return raw.trim();
}
